import React, {useMemo} from 'react';
import {useShallow} from 'zustand/react/shallow';
import translate from '@/utils/translate';
import searchCreatorsGetters from '@/views/creators/creator-crm/utils/searchCreatorsGetters';
import FilterButton from '@/components/filters/filter-button';
import useCreatorCrmStore, {
  creatorCrmActions,
} from '@/stores/creator-crm/creatorCrmStore';
import styles from './ActionDrawerButtons.module.scss';

type ActionDrawerButtonsProps = {
  onActionDrawerButtonClick?: (label: string) => void;
};

function ActionDrawerButtons(props: ActionDrawerButtonsProps) {
  const {onActionDrawerButtonClick} = props;
  const [filtersGroupsSnapshot, isFiltersDrawerOpen] = useCreatorCrmStore(
    useShallow((state) => [
      state.content.filtersState.filtersGroupsSnapshot,
      state.content.filtersState.isFiltersDrawerOpen,
    ])
  );

  const totalActiveFilters = useMemo(
    () =>
      searchCreatorsGetters.getTotalActiveFiltersCount(filtersGroupsSnapshot),
    [filtersGroupsSnapshot]
  );

  return (
    <div className={styles.container}>
      <FilterButton
        activeFilterCount={totalActiveFilters}
        onClick={() => {
          if (isFiltersDrawerOpen) {
            creatorCrmActions.closeFiltersDrawer();
          } else {
            creatorCrmActions.openFiltersDrawer();
          }
          onActionDrawerButtonClick?.(translate('Filters'));
        }}
      />
    </div>
  );
}

export default ActionDrawerButtons;
